module.exports = __webpack_public_path__ + "media/images/talent/case4-badge-f66232b56b2daf0e2c1da7dfaf801f01.png";